// extracted by mini-css-extract-plugin
export default {"ReadArticleContainer":"ReadNewsArticle_ReadArticleContainer__DJDzT","ReadArticle":"ReadNewsArticle_ReadArticle__OAg7c"};